import React from "react";
import { Box, BoxProps } from "@mui/material";

interface CenteredContentProps extends BoxProps {
  height?: string;
  gap?: string;
  children: React.ReactNode;
}

/**
 * Layout component that centers its children both vertically and horizontally.
 */
const CenteredContent: React.FC<CenteredContentProps> = ({
 height = "calc(100vh - 300px)",
 gap = "15px",
 children,
 ...rest
}) => {
  return (
    <Box display="grid" style={{ placeItems: "center", height }}{...rest}>
      <Box display="grid" style={{ placeItems: "center", gap }}>
        {children}
      </Box>
    </Box>
  );
};

export default CenteredContent;
